import WorkExperience from "./WorkExperience";
import classes from "./WorkExperiences.module.scss";

const WorkExperiences = () => {
  return (
    <div className={classes["experiences"]}>
      <div className={classes["experiences__label"]}>
        <h1>Work experience</h1>
      </div>

      <div className={classes["experiences__blocks"]}>
        <WorkExperience
          title="Junior System Consultant (Software Engineer)"
          company="Ørsted – Warsaw"
        >
          <ul>
            <li>
              Developed a front-end application to reconcile trade data between CCP and ETM systems (~150k daily transactions).
            </li>
            <li>
              Built an AI-based deal analytics proof-of-concept using LangChain4j and Quarkus to extract audit log summaries.
            </li>
            <li>
              Engineered dashboard modules with Chart.js (daily/monthly/yearly views) to visualize ~6 million yearly transactions.
            </li>
            <li>
              Created a high-performance Excel export feature (Apache POI) that fetches ~100k rows in under a minute.
            </li>
            <li>
              Designed a settlement item grouping and posting app using Java Virtual Threads — improved processing speed 10x.
            </li>
            <li>
              Developed a back-office front-end for Equias (ESM, ECM, ERR processes) integration.
            </li>
            <li>
              <strong>Tech stack:</strong> Angular, Java, Quarkus, LangChain4j, AG Grid, MSSQL, Chart.js, Apache POI, Azure, Kubernetes (AKS)
            </li>
          </ul>
        </WorkExperience>

        <WorkExperience
          alignRight={true}
          title="IT Explorer (Angular / Quarkus Developer)"
          company="Ørsted – Warsaw"
        >
          <ul className={classes["bullets__right"]}>
            <li>
              Built a Kafka consumer lag monitoring Quarkus extension to enhance AKS autoscaling and resilience.
            </li>
            <li>
              Developed a real-time Kafka monitoring dashboard using Server-Sent Events (SSE).
            </li>
            <li>
              Created Grafana dashboards to visualize Kafka lag metrics through Prometheus integration.
            </li>
            <li>
              <strong>Tech stack:</strong> Angular, Quarkus, Kafka, AKS, Azure, Grafana, Prometheus
            </li>
          </ul>
        </WorkExperience>

        <WorkExperience
          title="Backend Developer C# / .NET Intern"
          company="Infover – Kielce"
        >
          <ul>
            <li>
              Developed backend components (entities, repositories, services, controllers) aligned with company architecture.
            </li>
            <li>
              Designed and tested REST API endpoints with ASP.NET and Swagger.
            </li>
            <li>
              Participated in 5-person Agile team led by a Scrum Master.
            </li>
            <li>
              Managed tasks via Jira and versioned code using GitHub.
            </li>
            <li>
              <strong>Technologies:</strong> ASP.NET, C#, NHibernate, SQL, Swagger, GitHub, Jira
            </li>
          </ul>
        </WorkExperience>

        <WorkExperience
          alignRight={true}
          title="Computer Technician Intern"
          company="Ceramika Gres – Końskie"
        >
          <ul className={classes["bullets__right"]}>
            <li>
              Installed, updated, and tested computer equipment and software for new employee workstations.
            </li>
            <li>
              Performed system backups and assisted with hardware/software troubleshooting.
            </li>
          </ul>
        </WorkExperience>
      </div>

      <div className={classes["experiences__label"]}>
        <h1>Education</h1>
      </div>

      <div className={classes["experiences__blocks"]}>
        <WorkExperience 
          title="BSc. in Computer Science"
          company="Kielce University of Technology"
        >
          <ul>
            <li>
              Specialization: Information Systems
            </li>
          </ul>
        </WorkExperience>
      </div>
    </div>
  );
};

export default WorkExperiences;
